import React from "react";
import Slider from "react-slick";
import lokesh from "../../../assets/Images/Lokesh.jpg";
import Saeed from "../../../assets/Images/Saeed.jpg";
import azad from "../../../assets/Images/azad.webp";
import rightArrow from "../../../assets/Images/rightArrow.svg";
import leftArrow from "../../../assets/Images/leftArrow.svg";
import Card from "./Card";
import "./Testimonial.css";

const TESTIMONIALS = [
  {
    appName: "Sanskrit Safalyam",
    appDownloads: "2,27,189",
    teacherName: "Lokesh Kumar Sharma",
    teachersPhoto: lokesh,
    description:
    "Lokesh Kumar Sharma Sir is a National Gold medalist in his graduation in Sanskrit (Hons). With his YouTube channel, Lokesh Sir teaches more than 2 Lakhs students and has been helping students across the country compete for various government examination"
  },
  {
    appName: "Azad IAS Academy",
    appDownloads: "41499",
    teacherName: "Ravi Prakash Azad",
    teachersPhoto: azad,
    description:
    "Ravi Prakash Azad Sir established Azad IAS Academy to remove the shortcomings when it comes to teaching for the Civil Service Examinations. Using his own branded mobile application, he ensures to provide quality classroom programs, tests, and study materials."
  },
  {
    appName: "Shine Academy",
    appDownloads: "82096",
    teacherName: "Saeed Sir",
    teachersPhoto: Saeed,
    description:
    "Saeed Sir is a well-known educator & professional in the states of Andhra Pradesh & Telangana. He has grown from 500 new students joining the offline classes in a year to more than 10,000 now. They also have a vast online base of 80,000 students in their mobile app."
  },
];

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div onClick={() => onClick()}>
      <img src={rightArrow} />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div style={{ marginRight: "20px" }} onClick={() => onClick()}>
      <img src={leftArrow} />
    </div>
  );
}

function Testimonial({ isMobile }) {
  const slider = React.useRef(null);
  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    adaptiveHeight: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    centerMode: isMobile ? false : true,
    variableWidth: isMobile ? false : true,
    arrows: true,
  };

  return (
    <>
      <div className="testimonialHeading">
        Why are we the{" "}
        <span style={{ color: "#009AE0"}}> most trusted brand? </span>
      </div>
      <Slider ref={slider} {...settings} isMobile={isMobile}>
        {TESTIMONIALS.map((testimonial) => (
          <Card data={testimonial} />
        ))}
      </Slider>
      <div className="testimonialButtons">
        <SamplePrevArrow onClick={() => slider?.current?.slickPrev()} />
        <SampleNextArrow onClick={() => slider?.current?.slickNext()} />
      </div>
    </>
  );
}

export default Testimonial;
